const CashbackModel = {};

CashbackModel.RATE_TABLE = [
  {
    step: 0,
    rate: 0.05,
  },
  {
    step: 600,
    rate: 0.06,
  },
  {
    step: 700,
    rate: 0.07,
  },
  {
    step: 800,
    rate: 0.08,
  },
  {
    step: 900,
    rate: 0.09,
  },
  {
    step: 1000,
    rate: 0.10,
  },
  {
    step: 5000,
    rate: 0.15,
  },
  {
    step: 20000,
    rate: 0.2,
  },
];

const CashbackState = {
  CREDIT: {
    id: 1,
    title: 'Credit',
  },

  WITHDRAW: {
    id: 2,
    title: 'Withdraw',
  },
};

CashbackState.ID_TO_DATA = {
  [CashbackState.CREDIT.id]: CashbackState.CREDIT,
  [CashbackState.WITHDRAW.id]: CashbackState.WITHDRAW,
};

export {
  CashbackModel,
  CashbackState,
};
